import { Box, StyleProps } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { HorizontallyBoundedContainer } from "src/components/Layout/HorizontallyBoundedContainer";
import { AvelaToastMarginBottomDetector } from "src/hooks/useAvelaToast";

interface ParentFormsLayoutFooterProps extends StyleProps {
  children: ReactNode;
}

export function ParentFormsLayoutFooter(props: ParentFormsLayoutFooterProps) {
  const { children, ...styleProps } = props;
  const ref = React.useRef<HTMLDivElement>(null);

  return (
    <AvelaToastMarginBottomDetector elementRef={ref}>
      <Box
        ref={ref}
        bg="white"
        borderBlockStart="1px solid"
        borderColor="gray.200"
        bottom={0}
        position="sticky"
        width="100%"
      >
        <HorizontallyBoundedContainer
          columnGap={4}
          display="flex"
          paddingX={4}
          paddingY={2}
          rowGap={2}
          {...styleProps}
        >
          {children}
        </HorizontallyBoundedContainer>
      </Box>
    </AvelaToastMarginBottomDetector>
  );
}
